import React from "react";
import Image from "./../../assets/game_image_9-300x450.jpg";
import { IoHeartOutline } from "react-icons/io5";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { MdOutlineSettingsInputComponent } from "react-icons/md";
import { IoIosStar } from "react-icons/io";

const Card = () => {
  return (
    <div className="bg-white rounded-[8px] relative overflow-hidden flex">
      <div>
        <img
          src={Image}
          alt=""
          className="rounded-[8px] min-w-[100px] md:min-w-[280px] w-full p-2"
        />
        <div className="absolute top-3 left-3 bg-primary rounded-full w-12 h-12 font-rubik flex justify-center items-center text-white uppercase">
          -25%
        </div>
      </div>
      <div className="p-2 pb-6 flex flex-col justify-center gap-4">
        <p className="font-rubik font-regular text-sm text-gray-400">Games</p>

        <p className="font-rubik font-bold hover:text-primary">Wreckfest</p>
        <div className="flex gap-2">
          <p className="font-rubik font-bold text-primary">89$</p>
          <del className="font-rubik font-bold text-[#b0b8bf]">49$</del>
        </div>
        <div className="flex text-[#febf00]">
          <IoIosStar />
          <IoIosStar />
          <IoIosStar />
          <IoIosStar />
          <IoIosStar />
        </div>
        <p className="text-sm font-rubik text-[#828587]">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est
          repudiandae eligendi, dicta et aspernatur nulla cumque quis dolores id
          atque.
        </p>

        <div className="flex gap-4 font-rubik ">
          <div className="flex flex-col justify-center items-center">
            <div className="h-14 w-14 bg-gray-200 flex justify-center items-center rounded-full font-medium">930</div>
            <p className="text-sm text-gray-400">Days</p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="h-14 w-14 bg-gray-200 flex justify-center items-center rounded-full font-medium">930</div>
            <p className="text-sm text-gray-400">Days</p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="h-14 w-14 bg-gray-200 flex justify-center items-center rounded-full font-medium">930</div>
            <p className="text-sm text-gray-400">Days</p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="h-14 w-14 bg-gray-200 flex justify-center items-center rounded-full font-medium">930</div>
            <p className="text-sm text-gray-400">Days</p>
          </div>
        </div>
        <div className="bg-white">
          <div className="flex gap-2">
            <div className=" bg-primary flex justify-center items-center gap-1 rounded-full p-2 px-4 text-sm text-white">
              <HiOutlineShoppingBag size={15} /> Add to cart
            </div>
            <div className="rounded-full flex justify-center items-center p-2 text-xl text-gray-500 border">
              <IoHeartOutline />
            </div>
            <div className="rounded-full flex justify-center items-center p-2 text-xl text-gray-500 border">
              <MdOutlineSettingsInputComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
